import { AiOutlineBehance } from "react-icons/ai";
import { AiOutlineDribbble } from "react-icons/ai";
import { AiOutlineTwitter } from "react-icons/ai";
import { CgFacebook } from "react-icons/cg";
import { BsFillHeartFill } from "react-icons/bs";
import { FaComments } from "react-icons/fa";
import { BsFillPersonFill } from "react-icons/bs";
import React from "react";
import img from "../../../assets/img/blog/single_blog_1.png";
import img1 from "../../../assets/img/post/preview.png";
import img2 from "../../../assets/img/post/next.png";
import img3 from "../../../assets/img/blog/author.png";
import img4 from "../../../assets/img/blog/comment_1.png";
import img5 from "../../../assets/img/blog/comment_2.png";
import img6 from "../../../assets/img/blog/comment_3.png";

function Container() {
  return (
    <div>
      <img src={img} className="w-full" alt="" />
      <h1 className="mt-5 text-[#2b044d] Nui text-2xl font-semibold">
        Second divided from form fish beast made every of seas all gathered us
        saying he our
      </h1>
      <div className="flex mt-5 items-center gap-2">
        <BsFillPersonFill
          color="#999999"
          className="hover:text-[#8f1bdc] cursor-pointer"
          size={14}
        />
        <p className="hover:text-[#8f1bdc] cursor-pointer text-[#999999] text-sm Pop">
          Travel, Lifestyle
        </p>{" "}
        |
        <FaComments
          color="#999999"
          className="hover:text-[#8f1bdc] cursor-pointer"
          size={14}
        />
        <p className="hover:text-[#8f1bdc] cursor-pointer text-[#999999] text-sm Pop">
          03 Comments
        </p>
      </div>
      <p className="mt-5 text-[#707b8e] text-[15px] font-normal Pop leading-7">
        MCSE boot camps have its supporters and its detractors. Some people do
        not understand why you should have to spend money on boot camp when you
        can get the MCSE study materials yourself at a fraction of the camp
        price. However, who has the willpower
      </p>
      <p className="mt-5 text-[#707b8e] text-[15px] font-normal Pop leading-7">
        MCSE boot camps have its supporters and its detractors. Some people do
        not understand why you should have to spend money on boot camp when you
        can get the MCSE study materials yourself at a fraction of the camp
        price. However, who has the willpower to actually sit through a
        self-imposed MCSE training. who has the willpower to actually
      </p>
      <div className="p-10 bg-[#F2F3F7] mt-5">
        <div className="p-8 bg-white border-l-2 border-black">
          <p className="text-[#888888] text-base Pop Italic">
            MCSE boot camps have its supporters and its detractors. Some people
            do not understand why you should have to spend money on boot camp
            when you can get the MCSE study materials yourself at a fraction of
            the camp price. However, who has the willpower to actually sit
            through a self-imposed MCSE training.
          </p>
        </div>
      </div>
      <p className="mt-5 text-[#707b8e] text-[15px] font-normal Pop leading-7">
        MCSE boot camps have its supporters and its detractors. Some people do
        not understand why you should have to spend money on boot camp when you
        can get the MCSE study materials yourself at a fraction of the camp
        price. However, who has the willpower
      </p>
      <p className="mt-5 text-[#707b8e] text-[15px] font-normal Pop leading-7">
        MCSE boot camps have its supporters and its detractors. Some people do
        not understand why you should have to spend money on boot camp when you
        can get the MCSE study materials yourself at a fraction of the camp
        price. However, who has the willpower to actually sit through a
        self-imposed MCSE training. who has the willpower to actually
      </p>
      <div className="flex md:justify-between flex-col md:flex-row justify-center mt-5 items-center  border-t border-[#f0e9ff] pt-5">
        <h1 className="text-sm text-[#707b8e] Pop font-normal flex gap-3">
          <BsFillHeartFill color="#707b8e" size={16} /> Lily and 4 people like
          this
        </h1>
        <div className="flex gap-4">
          <CgFacebook color="#999999" size={18} />
          <AiOutlineTwitter color="#999999" size={18} />
          <AiOutlineDribbble color="#999999" size={18} />
          <AiOutlineBehance color="#999999" size={18} />
        </div>
      </div>
      <div className="flex md:justify-between flex-col md:flex-row justify-center mt-16 border-b border-[#eee] pb-5">
        <div className="flex gap-5 items-center">
          <img src={img1} alt="" />
          <div className="text-start">
            <h1 className="text-[#707b8e] text-base Pop font-normal">
              Prev Post
            </h1>
            <p className="text-[#2b044d] text-lg Nui hover:text-[#8f1bdc] font-medium">
              Space The Final Frontier
            </p>
          </div>
        </div>
        <div className="flex gap-5 items-center">
          <div className="text-start">
            <h1 className="text-[#707b8e] text-base Pop font-normal">
              Next Post
            </h1>
            <p className="text-[#2b044d] text-lg Nui hover:text-[#8f1bdc] font-medium">
              Telescopes 101
            </p>
          </div>
          <img src={img2} alt="" />
        </div>
      </div>
      <div className="mt-6 mb-16 p-10 bg-[#FBF9FF]">
        <div className="flex items-center gap-5">
          <img src={img3} alt="" />
          <div className="text-start">
            <h1 className="text-base text-[#2b044d] Nui font-medium">
              Harvard milan
            </h1>
            <p className="text-[15px] text-[#707b8e] Pop font-normal pt-3 leading-7">
              Second divided from form fish beast made. Every of seas all
              gathered use saying you're, he our dominion twon Second divided
              from
            </p>
          </div>
        </div>
      </div>
      <div className="mt-5 pt-5 pb-24 border-y border-[#eee]">
        <h1 className="pb-0 text-lg Nui text-[#2b044d] pt-7">05 Comments</h1>
        <div className="flex gap-5 items-center mt-14">
          <img src={img4} alt="" />
          <div className="text-start">
            <p className="text-[15px] text-[#777777] font-normal Pop leading-7">
              Multiply sea night grass fourth day sea lesser rule open subdue
              female fill which them Blessed, give fill lesser bearing multiply
              sea night grass fourth day sea lesser
            </p>
            <div className="flex justify-between mt-4">
              <div className="flex gap-3">
                <h1 className="text-[#2b044d] font-medium Nui text-base">
                  Emilly Blunt
                </h1>
                <p className="text-sm text-[#999999] Pop font-normal">
                  December 4, 2017 at 3:12 pm
                </p>
              </div>
              <p className="text-sm text-[#888888] font-normal hover:text-[#8f1bdc] cursor-pointer">
                REPLY
              </p>
            </div>
          </div>
        </div>
        <div className="flex gap-5 items-center mt-14">
          <img src={img5} alt="" />
          <div className="text-start">
            <p className="text-[15px] text-[#777777] font-normal Pop leading-7">
              Multiply sea night grass fourth day sea lesser rule open subdue
              female fill which them Blessed, give fill lesser bearing multiply
              sea night grass fourth day sea lesser
            </p>
            <div className="flex justify-between mt-4">
              <div className="flex gap-3">
                <h1 className="text-[#2b044d] font-medium Nui text-base">
                  Emilly Blunt
                </h1>
                <p className="text-sm text-[#999999] Pop font-normal">
                  December 4, 2017 at 3:12 pm
                </p>
              </div>
              <p className="text-sm text-[#888888] font-normal hover:text-[#8f1bdc] cursor-pointer">
                REPLY
              </p>
            </div>
          </div>
        </div>
        <div className="flex gap-5 items-center mt-14">
          <img src={img6} alt="" />
          <div className="text-start">
            <p className="text-[15px] text-[#777777] font-normal Pop leading-7">
              Multiply sea night grass fourth day sea lesser rule open subdue
              female fill which them Blessed, give fill lesser bearing multiply
              sea night grass fourth day sea lesser
            </p>
            <div className="flex justify-between mt-4">
              <div className="flex gap-3">
                <h1 className="text-[#2b044d] font-medium Nui text-base">
                  Emilly Blunt
                </h1>
                <p className="text-sm text-[#999999] Pop font-normal">
                  December 4, 2017 at 3:12 pm
                </p>
              </div>
              <p className="text-sm text-[#888888] font-normal hover:text-[#8f1bdc] cursor-pointer">
                REPLY
              </p>
            </div>
          </div>
        </div>
      </div>
      <h1 className="pt-16 pb-8 text-[#2b044d] text-lg Nui font-medium">
        Leave a Reply
      </h1>
      <div className="col-span-7">
        <textarea
          name=""
          id=""
          className="px-5 py-2 w-full border border-[#e5e6e9] font-normal text-[13px] outline-none"
          placeholder="Write Comment"
          rows="8"
        ></textarea>
        <div className="flex mt-5 flex-col md:flex-row gap-10">
          <input
            type="text"
            placeholder="Name"
            className="text-[#495057] border-[#e5e6e9] outline-none border px-5 py-2 w-full "
          />
          <input
            type="email"
            placeholder="Email"
            className="text-[#495057] border-[#e5e6e9] outline-none border px-5 py-2 w-full "
          />
        </div>
        <input
          type="text"
          placeholder="Websiite"
          className="text-[#495057] border-[#e5e6e9] outline-none border px-5 py-2 w-full mt-5"
        />
        <button className="tracking-[4px] lg:mb-0 mb-20 mt-10 border border-[#8f1bdc] text-[#8f1bdc] hover:bg-[#8f1bdc] bg-white hover:text-white py-4 px-10 text-sm font-normal">
          SEND MESSAGE
        </button>
      </div>
    </div>
  );
}

export default Container;
